import React from 'react';
import { Badge } from '../ui/badge';
import { CheckCircle } from 'lucide-react';
import { LOGO_URL } from './constants';

export const LandingHeader = () => (
  <header className="bg-white/80 backdrop-blur-md shadow-sm border-b sticky top-0 z-50">
    <div className="container mx-auto px-4 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <img
              src={LOGO_URL}
              alt="IwannaInsurance Logo Oficial"
              className="h-16 w-16 rounded-full object-cover shadow-xl border-4 border-white bg-white"
              style={{ filter: 'brightness(1.1) contrast(1.2)', imageRendering: 'crisp-edges' }}
            />
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse shadow-md border-2 border-white"></div>
          </div>
          <div>
            <div className="flex flex-col">
              <h1 className="text-3xl font-bold text-blue-600 tracking-wider leading-none">IWANNA</h1>
              <h2 className="text-lg font-medium text-red-500 -mt-1 tracking-wide">insurance</h2>
            </div>
            <p className="text-sm text-slate-600 font-medium mt-1">Protección digital inteligente</p>
          </div>
        </div>
        <Badge className="bg-gradient-to-r from-green-400 to-blue-400 text-white border-0 shadow-lg">
          <CheckCircle className="h-3 w-3 mr-1" />
          Verificado
        </Badge>
      </div>
    </div>
  </header>
);

export default LandingHeader;
